<script lang="ts" setup>
import { computed } from 'vue';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { gotoLogout } from '@/utils/auth';
import { useUserStore } from '@/stores';

const props = withDefaults(defineProps<{
  newTab?: boolean;
}>(), {
  newTab: false,
});

const userStore = useUserStore();

const avatarSrc = computed(() => {
  const photo = userStore.user.photo || '';

  if (!photo) {
    return '';
  }

  return /^https?:\/\//.test(photo) ? photo : `${import.meta.env.VITE_FILE_HOST}${photo}`;
});

const handleLogout = () => {
  gotoLogout(`${window.location.protocol}//${window.location.host}${window.location.pathname}`);
};
</script>

<template>
  <div class="component-user-menu">
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <Button variant="outline" size="icon" class="rounded-full size-10">
          <Avatar class="size-full">
            <AvatarImage :src="avatarSrc" :alt="userStore.user.nickname" class="object-contain" />
            <AvatarFallback>{{ userStore.user.nickname }}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent class="w-56" align="end">
        <DropdownMenuLabel>
          {{ userStore.user.nickname }}<br>
          <span class="text-[#888]">@{{ userStore.user.username }}</span>
        </DropdownMenuLabel>

        <DropdownMenuSeparator />

        <DropdownMenuGroup>
          <DropdownMenuItem>
            <RouterLink :to="`/profile/${userStore.user.username}`" class="block w-full h-full" :target="props.newTab ? '_blank' : undefined" :rel="props.newTab ? 'noopener noreferrer' : undefined">
              我的主页
            </RouterLink>
          </DropdownMenuItem>
          <DropdownMenuItem>
            <RouterLink to="/settings/profile" class="block w-full h-full" :target="props.newTab ? '_blank' : undefined" :rel="props.newTab ? 'noopener noreferrer' : undefined">
              个人中心
            </RouterLink>
          </DropdownMenuItem>
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuItem class="cursor-pointer" @click="handleLogout">
          退出登录
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>
